var _g, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path, _g2, _rect7, _rect8, _rect9, _rect10, _rect11, _path2, _g3, _g4, _rect12, _rect13, _rect14, _rect15, _rect16, _circle11, _rect17, _path3, _path4, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSocialContent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 357,
    height: 347,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#social-content_svg__filter0_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 170.321,
    y: 9,
    width: 138.983,
    height: 265.738,
    rx: 16,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.321,
    y: 9,
    width: 138.983,
    height: 265.738,
    rx: 16,
    stroke: "#EEE",
    strokeWidth: 0.555
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.22,
    cx: 189.841,
    cy: 46.156,
    r: 11.288,
    fill: "#C4C4C4"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.22,
    cx: 220.645,
    cy: 46.156,
    r: 11.288,
    fill: "#C4C4C4"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.22,
    cx: 251.453,
    cy: 46.156,
    r: 11.288,
    fill: "#C4C4C4"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.22,
    cx: 282.26,
    cy: 46.156,
    r: 11.288,
    fill: "#C4C4C4"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 189.723,
    cy: 46.039,
    r: 12.699,
    stroke: "url(#social-content_svg__paint0_linear)",
    strokeWidth: 0.706
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 182.604,
    cy: 79.368,
    r: 5.085,
    fill: "#C4C4C4"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 182.838,
    cy: 254.567,
    r: 5.085,
    fill: "#C4C4C4"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 220.53,
    cy: 46.039,
    r: 12.699,
    stroke: "url(#social-content_svg__paint1_linear)",
    strokeWidth: 0.706
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 251.335,
    cy: 46.039,
    r: 12.699,
    stroke: "url(#social-content_svg__paint2_linear)",
    strokeWidth: 0.706
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 282.142,
    cy: 46.039,
    r: 12.699,
    stroke: "url(#social-content_svg__paint3_linear)",
    strokeWidth: 0.706
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 177,
    y: 16,
    width: 40,
    height: 9,
    rx: 0.941,
    fill: "#C4C4C4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 191.017,
    y: 74.141,
    width: 26.104,
    height: 4.939,
    rx: 0.941,
    fill: "#C4C4C4"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 191.251,
    y: 249.34,
    width: 26.104,
    height: 4.939,
    rx: 0.941,
    fill: "#C4C4C4"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 191.017,
    y: 81.196,
    width: 21.635,
    height: 3.763,
    rx: 0.941,
    fill: "#C4C4C4"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 191.251,
    y: 256.395,
    width: 21.635,
    height: 3.763,
    rx: 0.941,
    fill: "#C4C4C4"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 258,
    y: 16,
    width: 44,
    height: 9,
    rx: 0.941,
    fill: "#C4C4C4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    fill: "#C4C4C4",
    d: "M170.32 90.838h138.983v151.918H170.32zM170.555 266.037h138.983v8.701H170.555z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#social-content_svg__filter1_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 9,
    width: 138.983,
    height: 265.738,
    rx: 16,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 9,
    width: 138.983,
    height: 265.738,
    rx: 16,
    stroke: "#EEE",
    strokeWidth: 0.555
  })), /*#__PURE__*/React.createElement("rect", {
    x: 54.506,
    y: 15.585,
    width: 51.737,
    height: 5.879,
    rx: 1.471,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.9,
    x: 16.645,
    y: 65.44,
    width: 62.789,
    height: 5.879,
    rx: 1.471,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.33,
    x: 16.645,
    y: 73.671,
    width: 57.616,
    height: 4.703,
    rx: 1.471,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.33,
    x: 16.645,
    y: 80.726,
    width: 47.974,
    height: 4.703,
    rx: 1.471,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.33,
    x: 16.645,
    y: 87.781,
    width: 47.974,
    height: 4.703,
    rx: 1.471,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.93,
    cy: 44.565,
    r: 15.286,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    fill: "#C4C4C4",
    d: "M12.477 125.153h44.356v38.241H12.477zM12.477 164.865h44.356v38.241H12.477zM12.477 204.576h44.356v38.241H12.477zM57.94 125.153h44.356v38.241H57.94zM57.94 164.865h44.356v38.241H57.94zM57.94 204.576h44.356v38.241H57.94zM103.41 125.153h44.356v38.241H103.41zM103.41 164.865h44.356v38.241H103.41zM103.41 204.576h44.356v38.241H103.41z"
  }))), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 42.276,
    y: 113.884,
    width: 7.29,
    height: 6.585,
    rx: 0.941,
    fill: "#C4C4C4"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 111.887,
    y: 114.119,
    width: 6.82,
    height: 6.114,
    rx: 0.706,
    stroke: "#C4C4C4",
    strokeWidth: 0.47
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.33,
    x: 64.617,
    y: 39.102,
    width: 12.934,
    height: 11.053,
    rx: 1.471,
    fill: "#C4C4C4"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.33,
    x: 92.836,
    y: 39.102,
    width: 12.934,
    height: 11.053,
    rx: 1.471,
    fill: "#C4C4C4"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.33,
    x: 121.059,
    y: 39.102,
    width: 12.934,
    height: 11.053,
    rx: 1.471,
    fill: "#C4C4C4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    stroke: "#000",
    strokeWidth: 0.235,
    d: "M11 125.055h138.983"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#social-content_svg__filter2_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 207.477,
    y: 68.262,
    width: 138.983,
    height: 265.738,
    rx: 16,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 207.477,
    y: 68.262,
    width: 138.983,
    height: 265.738,
    rx: 16,
    stroke: "#EEE",
    strokeWidth: 0.555
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.22,
    filter: "url(#social-content_svg__filter3_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 207.477,
    y: 68.262,
    width: 138.983,
    height: 265.738,
    rx: 16,
    fill: "#C4C4C4"
  }))), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 217,
    y: 76,
    width: 29,
    height: 1,
    rx: 0.227,
    fill: "#C4C4C4"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 247,
    y: 76,
    width: 29,
    height: 1,
    rx: 0.227,
    fill: "#C4C4C4"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 279,
    y: 76,
    width: 29,
    height: 1,
    rx: 0.227,
    fill: "#C4C4C4"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 279,
    y: 76,
    width: 18,
    height: 1,
    rx: 0.227,
    fill: "#C4C4C4"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 309,
    y: 76,
    width: 29,
    height: 1,
    rx: 0.227,
    fill: "#C4C4C4"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 220.687,
    cy: 87.979,
    r: 5.979,
    fill: "#C4C4C4"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 230.938,
    y: 86,
    width: 38.803,
    height: 4.939,
    rx: 0.941,
    fill: "#C4C4C4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M337.974 84.602a.352.352 0 10-.499-.499l-3.072 3.072-3.072-3.072a.353.353 0 00-.499.5l3.072 3.071-3.072 3.072a.352.352 0 10.499.5l3.072-3.073 3.072 3.072a.353.353 0 00.499-.499l-3.072-3.072 3.072-3.072z",
    fill: "#DDD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M320.316 88.594a.297.297 0 100-.594.297.297 0 000 .594zM322.395 88.594a.296.296 0 00.296-.297.296.296 0 10-.593 0c0 .164.133.297.297.297zM318.238 88.594a.297.297 0 100-.594.297.297 0 000 .594z",
    stroke: "#D6D6D6",
    strokeWidth: 0.594,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "social-content_svg__paint0_linear",
    x1: 189.723,
    y1: 32.987,
    x2: 189.723,
    y2: 59.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4438"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D8FF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "social-content_svg__paint1_linear",
    x1: 220.53,
    y1: 32.987,
    x2: 220.53,
    y2: 59.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4438"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D8FF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "social-content_svg__paint2_linear",
    x1: 251.335,
    y1: 32.987,
    x2: 251.335,
    y2: 59.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4438"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D8FF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "social-content_svg__paint3_linear",
    x1: 282.142,
    y1: 32.987,
    x2: 282.142,
    y2: 59.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4438"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D8FF4"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "social-content_svg__filter0_d",
    x: 160.043,
    y: 0.722,
    width: 159.539,
    height: 286.294,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "dilate",
    "in": "SourceAlpha",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.592157 0 0 0 0 0.596078 0 0 0 0 0.67451 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "social-content_svg__filter1_d",
    x: 0.722,
    y: 0.722,
    width: 159.539,
    height: 286.294,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "dilate",
    "in": "SourceAlpha",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.592157 0 0 0 0 0.596078 0 0 0 0 0.67451 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "social-content_svg__filter2_d",
    x: 197.199,
    y: 59.984,
    width: 159.539,
    height: 286.294,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "dilate",
    "in": "SourceAlpha",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.592157 0 0 0 0 0.596078 0 0 0 0 0.67451 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "social-content_svg__filter3_d",
    x: 197.477,
    y: 60.262,
    width: 158.983,
    height: 285.738,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "dilate",
    "in": "SourceAlpha",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.592157 0 0 0 0 0.596078 0 0 0 0 0.67451 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}

export default __webpack_public_path__ + "static/social-content.43312ff3.svg";
export { SvgSocialContent as ReactComponent };